import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';
import { dossierValuesService } from 'src/app/services/Dossier/values.service';

@Component({
    selector: 'dialog-comparateur',
    templateUrl: 'comparateur.component.html',
    styleUrls: ['comparateur.component.scss']
})
export class DialogComparateurComponent implements OnInit {

    isLoading = false;
    dossiersId = [];
    rapport: any;

    constructor(
        public dialogRef: MatDialogRef<DialogComparateurComponent>,
        public dossierValuesService: dossierValuesService,
        public appService: AppService,
        public cdf: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.isLoading = true;
        this.dossierValuesService.rapportComparateur(this.data.dossiersId)
        .subscribe((res) => {
            if (res.result && res.result.html) 
            {
                this.rapport = res.result.html;
                this.cdf.detectChanges();
            }
        },
        () => {
            this.isLoading = false;
        })
    }

    dismissDialog() {
        this.dialogRef.close();
    }

    export(type) {
        let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"})

        this.appService.downloadComparaison(this.data.dossiersId, type).subscribe((res)=>{
            console.warn("RES :", res);
            if(res) {
                let aDownload = document.createElement('a');
                aDownload.download = "Comparaison_" + dategeneration + '.' + type.toLowerCase();
                aDownload.href = URL.createObjectURL(res);
                document.body.appendChild(aDownload);
                aDownload.click();
                document.body.removeChild(aDownload);
            }
        })
    }
}